import omit from "lodash/omit";
import { IOfferTarifficationFormData } from "../../context/types";
import { ServiceRate } from "../../../../lib/types";
import { RateModes } from "../../../../lib/const/rateModes";

/**
 * Объект serviceRates для создания предложения (числовые идентификаторы)
 * @param {Props} props
 * @return {}
 */

interface Props {
  tarifficationValues: IOfferTarifficationFormData;
  fromDate: string;
  forAggregationRule: boolean; // true - транзационные для передачи в правила, false - нетранзакционные для передачи непосредственно в предложение
}

const omittedForAggregationRule = ["balanceTypeId", "priceWithVat", "toDate", "offeringId", "id"];
const omitted = [...omittedForAggregationRule, "aggregationRuleId"];

export const getServiceRatesBody = (props: Props): ServiceRate<string>[] | undefined => {
  const { tarifficationValues, fromDate, forAggregationRule } = props;
  if (forAggregationRule) {
    const serviceRates = tarifficationValues.serviceRates
      ?.filter(({ rateModeId }) => rateModeId === RateModes.TRAFFIC)
      .map((rate) => ({
        ...omit(rate, ...omittedForAggregationRule),
        fromDate,
      }));
    return serviceRates;
  }

  const serviceRates = tarifficationValues.serviceRates
    ?.filter(({ rateModeId }) => rateModeId !== RateModes.TRAFFIC)
    .map((rate) => ({
      ...omit(rate, ...omitted),
      fromDate,
    }));
  return serviceRates;
};
